import React from 'react';
import { CheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CHECKOUT_URL, BUY_ANCHOR } from '../utils/constants';
import { CtaButton } from './CtaButton';
const INCLUDED = ['Complete 6-Module Teaching System', '5 Strategic Bonuses', 'Ready-To-Teach Classes', 'Professional Yoga Sequences', 'Class Builder System', 'Pose & Teaching Reference', 'Student Progression Resources', 'Professional Instructor Templates', 'Lifetime Access', 'Instant Digital Delivery'];
export function Pricing() {
  return <section id={BUY_ANCHOR} aria-labelledby="pricing-title" className="w-full scroll-mt-4 bg-ivory px-4 py-10 sm:px-6" data-id="element-148" data-mp="1ru9hi3oa51ly">
      <div className="mx-auto max-w-2xl text-center" data-id="element-149" data-mp="20sljf1uljltp">
        <h2 id="pricing-title" className="font-head text-2xl font-extrabold uppercase leading-tight text-charcoal sm:text-3xl" data-id="element-150" data-mp="20rto7s4wvq3y">
          Everything included. One single price.
        </h2>
        <p className="mt-1 text-sm text-softgray" data-id="element-151" data-mp="3cao1g22j5x22">No subscriptions. No hidden charges.</p>

        <div className="mt-5 overflow-hidden rounded-3xl border-2 border-brand bg-white text-left shadow-xl shadow-brand/10" data-id="element-152" data-mp="3w1t7vvjtp176">
          <div className="bg-brand px-5 py-4 text-center text-white" data-id="element-153" data-mp="9siak3o6wr3s">
            <h3 className="font-head text-base font-extrabold uppercase leading-tight sm:text-xl" data-id="element-154" data-mp="9qe5vjigvo2g">
              Yoga Teaching Vault™ — Complete Box Set
            </h3>
            <p className="mt-0.5 text-xs text-white/85 sm:text-sm" data-id="element-155" data-mp="3daijbl1kl0ig">
              1 Main Box Set With 6 Modules + 5 Strategic Bonuses
            </p>
          </div>

          <div className="p-5" data-id="element-156" data-mp="3n6lo6ynt3d93">
            <p className="font-head text-[11px] font-bold uppercase tracking-wider text-softgray" data-id="element-157" data-mp="3n5ka0lbhuan5">
              What’s Included
            </p>
            <ul className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-158" data-mp="2uihgk7locq3r">
              {INCLUDED.map(item => <li key={item} className="flex items-start gap-2 text-sm leading-snug text-charcoal" data-id="element-159" data-mp="2zhau200yoh3x">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-160" data-mp="2rf1t7yr2rc5q" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-5 rounded-2xl bg-ivory p-4 text-center" data-id="element-161" data-mp="315mobc7jhyjw">
              <p className="text-sm text-softgray" data-id="element-162" data-mp="2w71mx9gjx8tv">
                Regular Price: <span className="line-through" data-id="element-163" data-mp="2w9xkuxsefxib">$97 USD</span>
              </p>
              <p className="font-head text-4xl font-extrabold text-brand sm:text-5xl" data-id="element-164" data-mp="28iin7ibki4de">$27 USD</p>
              <span className="mt-1 inline-block rounded-full bg-urgent px-3 py-1 font-head text-[11px] font-bold uppercase tracking-wide text-white" data-id="element-165" data-mp="23kgx4dfq54sf">
                Save $70
              </span>
              <p className="mt-2 font-head text-[11px] font-bold uppercase tracking-wide text-charcoal" data-id="element-166" data-mp="2dfimnadww8vj">
                One-Time Payment · Lifetime Access
              </p>
            </div>

            <div className="mt-4 flex flex-col items-center" data-id="element-167" data-mp="3ovh2py7ibv69">
              <CtaButton href={CHECKOUT_URL} data-id="element-168" data-mp="9uec5uymrka" />
              <p className="mt-2 text-xs text-softgray" data-id="element-169" data-mp="92gsphsyjrd">
                Backed by our 7-day money-back guarantee.
              </p>
              <ul className="mt-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-medium text-softgray" data-id="element-170" data-mp="3nf37yxvwg9yk">
                <li className="flex items-center gap-1.5" data-id="element-171" data-mp="3rfwxtwswjyu3">
                  <LockIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-172" data-mp="j0va6l0sa6zm" />
                  Secure Payment
                </li>
                <li className="flex items-center gap-1.5" data-id="element-173" data-mp="o07yzbb7to4u">
                  <ZapIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-174" data-mp="o1sub35ctb3r" />
                  Instant Access
                </li>
                <li className="flex items-center gap-1.5" data-id="element-175" data-mp="e9d81tn0y0d2">
                  <CreditCardIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-176" data-mp="e7sf28gcyphb" />
                  Card · Google Pay · Apple Pay
                </li>
              </ul>
              <p className="mt-1 text-[11px] text-softgray" data-id="element-177" data-mp="16rqz9aduuo36">
                You will be charged in your local currency.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}